import DividerWithText from '../../../../../components/DividerWithText';
import React, {useEffect} from 'react';
import RowResumeText from '../../../../../components/RowResumeText';
import { useTranslation } from 'react-i18next';
import {status} from "../../../../../enums/statusEnum";
import CustomDaySelector from "../../../../../components/CustomDaySelector";
import {getMaxWith} from "../../../../../Apis/functions";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const CafeteriaSummary = ({ item, deviceSelectedList, dayArray }) => {
    const { t } = useTranslation();

    useEffect(() => {
        getMaxWith('.same-width > .row-resume > .resume-text', '.same-width');
    }, []);

    return (<div className='row mb-5'>
        <DividerWithText title={t('details')} />
        <div className='d-flex justify-content-center'>
            <div className={"summary-container input-padding-top"}>
                <div className={"row"}>
                    <div className={"col-sm-12 col-md-6 col-lg-6 col-xl-6 p-0"}>
                        <RowResumeText title={t('name')} value={item?.name} tooltip={item?.name} className={"input-padding-bottom"}/>
                        <RowResumeText title={t('latitude')} value={item?.latitude} className={"input-padding-bottom"}  />
                        <RowResumeText title={t('status')} value={t(status[item?.statusId])} className={"input-padding-bottom"}  />
                    </div>
                    <div className={"col-sm-12 col-md-6 col-lg-6 col-xl-6 p-0 custom-col"}>
                        <div className={"same-width"}>
                            <RowResumeText title={t('code')} value={item?.code} className={"input-padding-bottom"} />
                            <RowResumeText title={t('longitude')} value={item?.longitude} className={"input-padding-bottom"}  />
                        </div>
                    </div>

                    <div className={"col-12 p-0"}>
                        <div className={"d-flex justify-content-end input-padding-bottom"}>
                            <CustomDaySelector dayArray={dayArray} setDayArray={() => {}} readonly={true} />
                        </div>
                    </div>

                    <div className={"col-sm-12 col-md-6 col-lg-6 col-xl-6 p-0"}>
                        <RowResumeText title={t('opening')} value={item?.openTime}  className={"input-padding-bottom"} />
                        <RowResumeText title={t('capacity')} value={item?.capacity} className={"input-padding-bottom"}  />
                    </div>
                    <div className={"col-sm-12 col-md-6 col-lg-6 col-xl-6 p-0 custom-col"}>
                        <div className={"same-width"}>
                            <RowResumeText title={t('closing')} value={item?.closeTime} className={"input-padding-bottom"}/>
                        </div>
                    </div>

                    <div className={"col-12 p-0"}>
                        <RowResumeText title={t('devices')} value={deviceSelectedList?.map(e => e.label)} className={"input-padding-bottom"}  />
                    </div>
                    <div className={"col-12 p-0 "}>
                        <RowResumeText title={t('description')} value={item?.description} className={"input-padding-bottom"}  />
                    </div>
                </div>
            </div>
        </div>
    </div>)
}

export default CafeteriaSummary;
